<template>
    <footer class="foot">
        <div class="foot-container">
            <div class="foot-item1">
                <div></div>
                <div>
                    <img src="../assets/home/logo.png" class="foot-logo" />
                    <div class="input-wrapper">
                        <input type="text" class="input-element input-with-icon-right">
                        <i class="fas fa-search icon-right"></i>
                    </div>
                </div>
            </div>
            <div class="foot-item1">
                <div style="font-weight:bold;" class="foot-title">ACCUEIL</div>
                <div style="display: flex; justify-content: center; margin: 30px 0; font-size: 12px; color: #333;">
                    <div style="width:150px;">SOINS VISAGE</div>
                    <div style="flex: 1;">NOTRE HISTOIRE</div>
                </div>
                <div style="display: flex; justify-content: center; margin: 20px 0; font-size: 12px; color: #333; ">
                    <div style="width: 150px;">MAQUILLAGE</div>
                    <div style="flex: 1;">ACCUEIL</div>
                </div>
            </div>
            <div style="font-size: 12px; " class="foot-item2">
                <div style="font-weight:bold;text-align:left;" class="foot-title">CONTACTEZ-NOUS</div>
                <div style="margin: 20px 0; text-align: left; color: #333;">
                    9 rue des Bateliers 67550 VENDENHEIM FRANCE
                </div>
                <div style="margin: 30px 0; text-align: left; color: #333;">
                    Diannas@gmail.com
                </div>
                <div style="margin: 30px 0; text-align: left; color: #333;">
                    0033 620133315
                </div>
            </div>
            <div  class="foot-item3">
                <div style="font-weight:bold;" class="foot-title foot-title-last">SUIVEZ-NOUS</div>
                <div style="margin-top:10px;">
                    <img src="../assets/foot/f.png" style=" cursor: pointer;" class="foot-title-last-image" />
                    <img src="../assets/foot/x.png" style=" cursor: pointer;" class="foot-title-last-image" />
                    <img src="../assets/foot/y.png" style=" cursor: pointer;" class="foot-title-last-image" />
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'NavigationFoot',
        data() {
            return {
                name: ''
            }
        }
    }
</script>

<style scoped>
    .foot {
        border-top: 1px solid rgb(228, 228, 228);
        padding: 5.72917vw 3.65726% 5.20833vw;
        margin: 4vw 0% 0vw;
        background: white;
    }


    .input-wrapper {
        position: relative;
        margin: 25px 0;
    }

    .input-element {
        width: 200px;
        padding: 12px 15px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        font-size: 16px;
        color: #606266;
        transition: border-color 0.3s;
    }

        .input-element:focus {
            outline: none;
            border-color: #409eff;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }

        .input-element:hover {
            border-color: #c0c4cc;
        }

    /* 右侧图标 */
    .input-with-icon-right {
        padding-right: 40px;
    }

    .icon-right {
        position: absolute;
        left: 220px;
        top: 50%;
        transform: translateY(-50%);
        color: black;
        font-size: 16px;
        cursor: pointer;
    }
</style>